import { Component, Input } from '@angular/core';
import { ControlTemplate } from 'src/app/rent-module/components/form/entities/controlTemplate';


@Component({
  selector: 'app-timeEntriesInput-control-value-view, [app-timeEntriesInput-control-value-view]',
  templateUrl: './timeEntriesInput-control-value-view.component.html',
  styleUrls: ['./timeEntriesInput-control-value-view.component.scss']
})
export class TimeEntriesInputControlValueViewComponent {

  @Input() controlTemplate: ControlTemplate;

  constructor(
  ) {
  }

  public showSuffix(): boolean {
    return this.controlTemplate?.settings?.suffix;
  }

}
